import { render, staticRenderFns } from "./PackingOption.vue?vue&type=template&id=3d5d272f&"
import script from "./PackingOption.vue?vue&type=script&lang=js&"
export * from "./PackingOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports